/** @jsxImportSource react */
import React from "react";

import { colorCSS } from "../../styles";

// SSR-compatible component using inline styles instead of Compiled CSS

type LabelDivProps = React.HTMLAttributes<HTMLDivElement> & {
    color: string;
};

export const LabelDiv = ({
    color,
    style,
    children,
    ...props
}: LabelDivProps) => (
    <div
        style={{
            alignItems: "center",
            backgroundColor: colorCSS(color),
            borderRadius: "0.3925rem",
            boxShadow: `-5px 5px 0 0 ${colorCSS("N900", 0.1)}`,
            color: colorCSS("N0"),
            display: "flex",
            fontSize: "18.83px",
            gap: "0.5rem",
            paddingRight: "0.5rem",
            position: "absolute",
            transition: "box-shadow 0.1s, background-color 1s",
            userSelect: "none",
            whiteSpace: "nowrap",
            ...style
        }}
        {...props}
    >
        {children}
    </div>
);
